export const dialogAction = (props) => {
    return {
        openEntryDialog: (data) => {
            props.dispatch({ type: OPEN_ENTRY_DIALOG, data });
        },
    };
};

const OPEN_ENTRY_DIALOG = 'OPEN_ENTRY_DIALOG';
export { OPEN_ENTRY_DIALOG };
